import { queryClient } from '@/tanstack-query.ts';
import type { DirectoryField } from '@/modules/counterparty/counterparty-master/consts/directory.const.ts';
import { SegmentQueryOptions } from '@/modules/counterparty/query-options/segment.query-options.ts';
import { RegionQueryOptions } from '@/modules/counterparty/query-options/region.query-options.ts';

export async function fetchDirectoryList(field: DirectoryField, signal?: AbortSignal) {
  if (field === 'segment') {
    return queryClient.fetchQuery({
      ...SegmentQueryOptions.getList(signal),
      staleTime: 0,
    });
  }

  return queryClient.fetchQuery({
    ...RegionQueryOptions.getList(signal),
    staleTime: 0,
  });
}
